module.exports = __webpack_public_path__ + "static/media/KGS.f3a910af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/KGS.svg
// module id = 2366
// module chunks = 7